import React from "react";
import styled from "styled-components";
import ReactQuill from "react-quill";
import { FormGroup, FormFeedback, Label, Col } from "reactstrap";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" }
    ],
    ["clean"]
  ]
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent"
];

const Wysiwyg = ({ onChange, onBlur, ...props }) => {
  return (
    <ReactQuill
      theme="snow"
      formats={formats}
      modules={modules}
      onChange={(newValue, delta, source) => {
        if (source === "user") {
          onChange(newValue);
        }
      }}
      onBlur={(range, source, quill) => {
        onBlur(quill.getHTML());
      }}
      {...props}
    />
  );
};

const renderWysiwyg = ({ input, meta, ...props }) => {
  const showError = meta.touched && meta.error;
  return (
    <FormGroup color={showError ? "danger" : ""}>
      <Wysiwyg {...input} {...props} valid={showError ? false : undefined} />
      {showError && <Error>{meta.error}</Error>}
    </FormGroup>
  );
};

const renderWysiwygWithLabel = ({
  input,
  column,
  meta,
  label,
  labelCol,
  inputCol,
  ...props
}) => {
  const showError = meta.touched && meta.error;
  return (
    <FormGroup color={showError ? "danger" : ""} row>
      <Label for={input.field} xs={labelCol || "1"}>
        {label}
      </Label>

      <Col xs={inputCol || "11"}>
        <Wysiwyg {...input} {...props} valid={showError ? false : undefined} />
        {showError && <Error>{meta.error}</Error>}
      </Col>
    </FormGroup>
  );
};

const Error = styled(FormFeedback)`font-size: 12px;`;

export { Wysiwyg, renderWysiwyg, renderWysiwygWithLabel };



// WEBPACK FOOTER //
// ./src/components/Form/Wysiwyg.js